import { useQuery } from '@apollo/client'

import { PipelineItemType } from '@flowwai-frontend/bps-officer-web/graphql'

import {
   GetPinnedPipelineItemsCountForUserDocument,
   GetPinnedPipelineItemsCountForUserQuery,
   GetPinnedPipelineItemsCountForUserQueryVariables
} from '../apis/GetPinnedPipelineItemsCountForUser/query.generatedTypes'

const useGetScheduledPipelineItemsCount = (): number | undefined => {
   const { data } = useQuery<
      GetPinnedPipelineItemsCountForUserQuery,
      GetPinnedPipelineItemsCountForUserQueryVariables
   >(GetPinnedPipelineItemsCountForUserDocument, {
      variables: {
         params: {
            pipelineItemTypes: [
               PipelineItemType.Lead,
               PipelineItemType.Deal,
               PipelineItemType.CustomObject,
               PipelineItemType.Application
            ]
         }
      },
      fetchPolicy: 'cache-only'
   })

   return data ? data.getPinnedPipelineItemsCountForUser.totalCount : undefined
}

export default useGetScheduledPipelineItemsCount
